/**
 * Deposit Method View
 */

define(function(require, exports, module) {
    'use strict';

    const BaseView = require('common/base.view');
    const server = require('server');
    const cashierUtil = require('modules/cashier/cashier.util');
    const Form = require('class/form.class');
    const i18n = require('i18n');
    const $ = require('j');
    const config = require('config');

    module.exports = BaseView.extend({

        events: {
            'click .fn-easypg-cancel': 'cancelEasyPG'
        },

        template: 'easypg-deposit.method',

        initialize: function(options) {
            this.options = options;

            BaseView.prototype.initialize.apply(this, arguments);
        },

        cancelEasyPG: function() {
            this.options.onClose();
        },

        initializeEasyPG: async function(response, data) {
            const baseURL = response.data.headerParameters.Location[0];
            const json = JSON.parse(response.data.headerParameters['X-Redirect-Content'][0]);
            const { authToken, merchantPrePayCallback } = json;
            const epgJSUrl = config.get('dynamicTags.DTAG_EPG_JS_URL');

            await $.getScript(epgJSUrl || 'https://epgjs-rendercashier-stg.easypaymentgateway.com/js/public/epgjs-3.8.0-min.js');

            window.EPGJS_COMM.setEpgBaseUrl(baseURL);
            window.EPGJS_I18N.setTranslate((key, params) => i18n.t(`playtech.mobile.system.mobile-cashier.method.EasyCC.translations.${key}`, ...params ?? []));
            window.EPGJS_STYLE.setCssTheme(window.EPGJS_STYLE.DEFAULT_BOOTSTRAP_THEME);
            window.EPGJS_COMM.setMerchantPrePayCallback(this.prepareEasyPGFinalizationFn(merchantPrePayCallback));

            if (data.field2) {
                this.$('#epgjs-container')[0].addEventListener('onRenderedCashier', () => {
                    const [, lastDigits] = data.field2.split('****');
                    const card = this.$(`[data-i18n-static*="${lastDigits}"]`);

                    this.$('#epgjs-cashier .panel').hide();

                    card.parent().parent().show();
                    card.trigger('click');
                }, { once: true });

                window.EPGJS_COMM.setOnlyRegisteredAccounts(true);
                window.EPGJS_COMM.setShowOnlyCardRegister(false);
                window.EPGJS.renderRegisteredAccounts(authToken,
                    'epgjs-container',
                    'epgjs-custom-form',
                    'CreditCards'
                );
            } else {
                this.$('#epgjs-container')[0].addEventListener('onRenderedCashier', () => {
                    this.$('#epgjs-cashier-quickpay-form-field-creditcards-rememberme').attr('checked', true);
                });

                window.EPGJS_DIY.setDiy({
                    'epgjs-cashier-quickpay-form': 'epgjs-custom-form',
                    'cardNumber': 'epgjs-pan',
                    'expDate': 'epgjs-expdate',
                    'chName': 'epgjs-chName',
                    'cvnNumber': 'epgjs-cvnNumber',
                    'rememberMe': 'epgjs-rememberme',
                    'epgjs-cashier-quickpay-form-button-CreditCards': 'epgjs-pay-btn',
                });
                window.EPGJS.renderQuickDepositByPaysol(authToken,
                    'epgjs-container',
                    'epgjs-custom-form',
                    'CreditCards'
                );
            }
        },

        prepareEasyPGFinalizationFn: function(merchantPrePayCallback) {
            const merchantPrePayCallbackURL = new URL(merchantPrePayCallback);
            const getParameters = Array.from(merchantPrePayCallbackURL.searchParams.entries())
                .map(([key, value]) => ({ key, value }));

            return async (prePayData) => {
                this.form.showLoading();

                try {
                    const response = await server.send({
                        ID: 35760,
                        responses: [35761, 35762],
                        headers: [{
                            key: 'prepayToken',
                            value: prePayData.prepayToken
                        }],
                        getParameters
                    });

                    window.location.href = response.data.redirectData.location;
                } catch (e) {
                    cashierUtil.notifyTransactionStatus('action=deposit&status=error&initiator=cashier_backbone');
                    this.cancelEasyPG();
                } finally {
                    this.form.hideLoading();
                }
            };
        },

        render: function() {
            BaseView.prototype.render.apply(this, arguments);

            this.$el.html(this.tmpl(this.template, {}));

            this.form = new Form(this.$('form'));

            return this;
        }
    });
});
